import types from './actionTypes';
import { ProductActions } from './actions';

import { productState, emptyProduct } from './state';
import { State } from './types';

export default function product(state = productState, action: ProductActions): State {
  switch (action.type) {
    case types.REQUEST_PRODUCT_LOADING:
      return {
        ...state,
        isFetching: true,
        errMsg: '',
        product: { ...emptyProduct },
      };
    case types.REQUEST_PRODUCT_FAILURE:
      return {
        ...state,
        isFetching: false,
        errMsg: action.payload,
      };
    case types.REQUEST_PRODUCT_SUCCESS:
      return {
        ...state,
        product: action.payload,
        isFetching: false,
      };
    case types.REQUEST_PRODUCT_MODAL:
      return {
        ...state,
        productModal: action.payload,
      };
    case types.CHANGE_SIZE:
      return { ...state, size: action.payload };
    case types.CHANGE_SIZE_MODAL:
      return { ...state, sizeModal: action.payload };
    case types.SET_SIZE_ERR_MSG:
      return { ...state, sizeErrMsg: action.payload };
    case types.SET_CROSS_SELL_LOADING:
      return { ...state, crossSellIsLoading: action.payload };
    case types.SET_UP_SELL_LOADING:
      return { ...state, upSellIsLoading: action.payload };
    case types.REQUEST_YOTPO_SUCCESS:
      return {
        ...state,
        yotpoBottomline: action.payload.bottomline,
        yotpoReviews: action.payload.reviews,
      };
    default:
      return state;
  }
}
